type IndexName = '^HSI' | '^HSTECH' | '^HSCEI' | '^DJI' | '^GSPC' | '^IXIC';

export const stockIsHKIndex = (stockCode: string): boolean => {
  return stockCode === '^HSI' || stockCode === '^HSTECH';
};

export const stockIsUSIndex = (stockCode: string): boolean => {
  return stockCode === '^DJI' || stockCode === '^GSPC' || stockCode === '^IXIC';
};

export const stockIsIndex = (stockCode: string): stockCode is IndexName => {
  return stockIsHKIndex(stockCode) || stockIsUSIndex(stockCode);
};

export const stockHasMarketSMA = (
  stockCode: string
): stockCode is IndexName => {
  return (
    stockCode === '^DJI' ||
    stockCode === '^GSPC' ||
    stockCode === '^IXIC' ||
    stockCode === '^HSI' ||
    stockCode === '^HSTECH'
  );
};

export const eligibleForHKEXProfile = (stockCode: string): boolean => {
  return new RegExp('^\\d+$').test(stockCode);
};

/**
 * Convert AWS formatted stock code to 5 digit stock code
 * @param awsStockCode
 * @returns
 */
const normalizeStockCode = (awsStockCode: string): string =>
  awsStockCode.split('.')[1].padStart(5, '0');

export const normalizeStockCodeInItem = <
  T extends {
    StockCode: string;
  },
>(
  item: T
): T & { stockCode: string } => {
  // the format of stock code is hk.700 instead of 00700
  // we need to do a transform here
  const stockCode = normalizeStockCode(item['StockCode']);
  return {
    ...item,
    stockCode,
  };
};
